import { render, staticRenderFns } from "./CodeDetailList.vue?vue&type=template&id=0a86aa97&scoped=true"
import script from "./CodeDetailList.vue?vue&type=script&lang=js"
export * from "./CodeDetailList.vue?vue&type=script&lang=js"
import style0 from "./CodeDetailList.vue?vue&type=style&index=0&id=0a86aa97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a86aa97",
  null
  
)

export default component.exports